export default {
  init() {
    // LOADER
    $(window).load(function() {
      $('#loader').hide('slow');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js